import React from "react";
import "./AboutUs.css";

const AboutUs = () => (
  <>
    <button
      onClick={() => {
        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = '/';
        }
      }}
      style={{
        position: 'fixed',
        top: '12px',
        left: '12px',
        margin: 0,
        padding: '4px 10px',
        borderRadius: '4px',
        border: 'none',
        background: '#f5f5f5',
        color: '#555',
        fontWeight: 500,
        cursor: 'pointer',
        fontSize: '0.95em',
        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        transition: 'background 0.2s',
        zIndex: 100,
      }}
      onMouseOver={e => e.currentTarget.style.background = '#e0e0e0'}
      onMouseOut={e => e.currentTarget.style.background = '#f5f5f5'}
      aria-label="Go back"
    >
      ← Back
    </button>
    <div className="aboutus-container">
    <h1 style={{ textAlign: 'center', fontWeight: 'bold' }}>About UsmaApp</h1>
    <p style={{ textAlign: 'center' }}>
      UsmaApp is a modern social media platform created to connect people, share stories, and foster meaningful interactions. Our platform is designed with the user in mind, ensuring a smooth and enjoyable experience for everyone. UsmaApp is more than just a social platform—it's a vibrant community where ideas flourish and friendships are formed.
    </p>
    <section>
      <h2 style={{ color: '#3182ce' }}>Our Mission</h2>
      <p>
        At UsmaApp, our mission is to empower users to express themselves, build communities, and stay connected in a safe and engaging environment. We strive to break barriers and bring people together, no matter where they are in the world. User safety and data protection are our top priorities, ensuring your information remains secure at all times.
      </p>
    </section>
    <section>
      <h2 style={{ color: '#3182ce' }}>Who We Serve</h2>
      <p>
        UsmaApp welcomes everyone—from students and professionals to families and creators. Whether you're looking to connect with friends, join interest-based groups, or share your story, UsmaApp is here to support your journey and help you build lasting relationships.
      </p>
    </section>
    <section>
      <h2 style={{ color: '#3182ce' }}>Features</h2>
      <ul>
        <li>Secure messaging</li>
        <li>Live streaming</li>
        <li>Group chats</li>
        <li>Story sharing</li>
        <li>Privacy-focused settings</li>
      </ul>
      <p>
        We continuously innovate to add new features that enhance your social experience and keep you connected with what matters most. Our intuitive interface makes it easy for users of all ages to connect, share, and discover new content. UsmaApp adapts to your needs, offering personalized recommendations and tools to help you make the most of your social experience.
      </p>
    </section>
    <section>
      <h2 style={{ color: '#3182ce' }}>Community Values</h2>
      <p>
        We value inclusivity, creativity, and user privacy. UsmaApp is committed to providing a respectful and supportive space for everyone. Our community thrives on respect, kindness, and collaboration. We encourage users to share their stories and celebrate diversity.
      </p>
    </section>
    <section>
      <h2 style={{ color: '#3182ce' }}>Innovation</h2>
      <p>
        We leverage the latest technology to deliver a seamless social experience, with regular updates and new features based on user feedback. By listening to our users, we ensure that UsmaApp evolves to meet the changing needs of the digital world. With UsmaApp, you’re never alone—our support team and community are always here to help and inspire you.
      </p>
    </section>
    <section>
      <h2 style={{ color: '#3182ce', fontWeight: 'bold' }}>About AtoZ Automation Solutions Pvt. Ltd</h2>
      <p style={{ textAlign: 'center' }}>
        UsmaApp is a project by AtoZ Automation Solutions Pvt. Ltd, a company dedicated to delivering innovative technological solutions that address real-world challenges across industries.
      </p>
    </section>
    <section>
      <h2 style={{ color: '#3182ce' }}>Contact Us</h2>
      <p>
        For feedback, please reach out to us at <a href="mailto:support@usmapp.com">support@usmapp.com</a>.<br />
        For support, contact <button style={{ color: '#3182ce', background: 'none', border: 'none', textDecoration: 'underline', cursor: 'pointer', padding: 0 }} onClick={() => window.location.href = '/feedback'}><span style={{ fontSize: '1em', fontWeight: 'bold' }}>feedback@usmapp.com</span></button>.<br />
        We value your input and are here to help you with any questions or concerns.
      </p>
    </section>
    </div>
  </>
);

export default AboutUs;
